export const footerLinks = [
    { label: 'DMCA', href: 'https://support.giphy.com/hc/en-us/articles/360020287091-GIPHY-DMCA-Copyright-Policy' },
    {
        label: 'Community Guidelines',
        href: 'https://support.giphy.com/hc/en-us/articles/360020286811-GIPHY-Community-Guidelines',
    },
    {
        label: 'Privacy Guidelines',
        href: 'https://support.giphy.com/hc/en-us/articles/360032872931-GIPHY-Privacy-Policy',
    },
    {
        label: 'Copyright',
        href: 'https://support.giphy.com/hc/en-us/articles/360020287091-GIPHY-DMCA-Copyright-Policy',
    },
    {
        label: 'Manage Cookies',
        onClick: () => {
            window.Didomi && window.Didomi.preferences.show()
        },
    },
]
